export default __webpack_public_path__ + "static/45-c6448abe734b32eac7625f1b3f74c818.png";